/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "local 0.1.0",
    versionChannel: "local",
    buildDate: "2026-08-13T15:57:08.147Z",
    commitHash: "79d1ca0f45d79e28c3a0658bbc6b8430d26ef308",
};
